import React, { useState } from "react";
import { Link } from "react-router-dom";
import { scrollToSection } from "../../utils/scrollToSection.ts";
import { FaBars, FaTimes } from "react-icons/fa";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sections = ["about", "services", "team", "clients"];

  return (
    <nav className="bg-primary text-secondary sticky top-0 left-0 w-full shadow-md z-50">
      <div className="container max-w-full mx-auto flex items-center justify-between px-6 py-4 md:px-10">

        {/* Logo */}
        <div className="flex-1">
          <Link
            to="/"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="text-4xl font-logo font-bold"
          >
            Elevate
          </Link>
        </div>

        <div className="hidden md:flex flex-grow justify-center space-x-8">
          {sections.map((section) => (
            <a
              key={section}
              href={`/#${section}`}
              onClick={() => {
                scrollToSection(section);
              }}
              className="hover:underline"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          ))}
        </div>

        {/* Contact Button - Desktop */}
        <div className="flex-1 flex justify-end">
          <button
            type="reset"
            onClick={() => {
              window.location.href = "/#contact";
            }}
            className="hidden md:block px-4 py-2 md:px-6 md:py-3 text-sm md:text-base lg:text-lg 
               text-primary bg-secondary rounded hover:bg-blue hover:text-text"
          >
            Get In Touch
          </button>
        </div>

        {/* Hamburger Menu Button (Mobile Only) */}
        <button
          className="md:hidden text-secondary focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden fixed top-0 left-0 w-full h-full bg-primary transform transition-transform ${isOpen ? "translate-x-0" : "-translate-x-full"
          } z-50 flex flex-col items-center justify-center space-y-6`}
      >
        {/* Close Button */}
        <button
          className="absolute top-5 right-5 text-secondary focus:outline-none"
          onClick={() => setIsOpen(false)}
        >
          <FaTimes size={32} />
        </button>

        {/* Navigation Links - Mobile */}
        {sections.map((section) => (
          <a
            key={section}
            href={`/#${section}`}
            onClick={() => {
              scrollToSection(section);
              setIsOpen(false);
            }}
            className="text-2xl text-secondary hover:underline"
          >
            {section.charAt(0).toUpperCase() + section.slice(1)}
          </a>
        ))}

        {/* Contact Button - Mobile */}
        <button
          type="reset"
          onClick={() => {
            window.location.href = "/#contact";
            setIsOpen(false);
          }}
          className="px-6 py-3 text-lg text-primary bg-secondary 
             rounded hover:bg-blue hover:text-text"
        >
          Get In Touch
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
